<template>
  <div style="background:#e4e4e4 !important">
    <div class="footerWrap parentWrap">
        <div class="footerContainer parentContainer">


          <div class="col spoonWrap">
            <a href="javascript:void(0)" class="spoon">
              <img src="./images/footerSpoonPopClear.png" alt="" class="popup">
              <img src="./images/smallspoon.png" alt="" class="popup" style="left: 180px; top: 60px">
              <div class="spoontext" onclick="window.location='../../funfacts.html';">
                The company founders, Burt Baskin and Irv Robbins, were
                brothers-in-law. Burt married Irv's sister Shirley in 1942...
              </div>
              <div class="clicktext">Click for more...</div>
            </a>
          </div>

          <div class="col">
            <a target="_blank" class="social facebook" href="https://web.facebook.com/MYBaskinRobbins/?_rdc=1&amp;_rdr">
              Facebook</a>

            <a target="_blank" class="social instagram" href="https://www.instagram.com/brmalaysia/?hl=en">
              Instagram</a>

            <a target="_blank" class="social youtube" href="https://www.youtube.com/channel/UCLndlH6UNEsNJVCpl9usf5w">
              Youtube</a>
          </div>

          <div class="col">
            <ul>
              <li class="heading">
                <a href="../../products/icecream.html">ICE CREAM</a>
              </li>

              <li>
                <a href="../icecream/flavors.html">Find a Flavor</a>
              </li>

              <li>
                <a href="../icecream/handpacked.html">Handpacked</a>
              </li>
              <li>
                <a href="../icecream/specialties007f.html">Sundaes</a>
              </li>
              <li>
                <a href="../icecream/specialties.html">Mix 'N Shake</a>
              </li>
            </ul>
          </div>

          <div class="col">
            <ul>
              <li class="heading">
                <a href="../../products/cake/cakegallery.html">CAKES</a>
              </li>

              <li>
                <a href="../../products/cake/cakegallery.html">
                  Cake Gallery
                </a>
              </li>
            </ul>
          </div>

          <div class="col">
            <ul>
              <li class="heading">
                <a href="../../aboutus.html">ABOUT US</a>
              </li>

              <li>
                <a href="../../aboutus/history.html"> Our History </a>
              </li>

              <li>
                <a href="../../funfacts.html"> Fun Facts </a>
              </li>
            </ul>
          </div>
          <div class="col">
            <ul>
              <li class="heading">
                <a href="../../Buy-now.html">OTHER</a>
              </li>
              <li>
                <a href="../../Buy-now.html"> Corporate Purchase</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="footerBaseWrap parentWrap">
        <div class="footerBaseContainer parentContainer" style="height:43px!important">
          <div class="footerCenterWrap">
            <a class="none" href="../../privacypolicy.html">Privacy Policy</a>

            <a class="none" href="../../termsofuse.html">Terms of Use</a>

            <a class="none" href="../../careers.html">Join the Team</a>

            <a class="none" href="../../faqs.html">FAQs</a>
          </div>
        </div>
      </div>
      <div class="parentWrap" style="padding-bottom:20px;">
        <div class="footerBaseContainer parentContainer">
          <div class="footerCenterWrap" style="left: 0; width: 100%;">
            <p style="text-align: center; color: #595959;font-size: 11px;">
              Copyright © 2021. All Rights Reserved by Golden Scoop Sdn Bhd
              (169609-A)<br>
              A-16-1 Tower A, Northpoint Office, Wilayah Persekutuan, 1, Medan
              Syed Putra Utara, Mid Valley City, 59200 Kuala Lumpur, Federal
              Territory of Kuala Lumpur
            </p>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
export default {
  name: "Header",
  props: {
    msg: String,
    
  },
  data(){
    return{
      mobileTitleBoolean:false

    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

.footerWrap {background:url(./images/footerBg.png) top repeat-x; height:166px; clear:both;}
.footerContainer .col {width:137px; float:left; margin:23px 25px 0 43px;}
.footerContainer .col.spoonWrap {margin:0 0 0 53px; position:relative; top:-13px; width:82px;}
.footerContainer .col.spoonWrap .spoon {display:block; width:42px; height:145px; background-image:url(./images/footerSpoon.png); background-position:right;}
.footerContainer .col.spoonWrap .spoon img {display:none; position:absolute; left:36px; top:-18px; z-index:100;}
.footerContainer .col.spoonWrap .spoon:hover {background-position:left;}
.footerContainer .col.spoonWrap .spoon:hover img {display:block;}
.footerContainer .col.socialLinks {margin:30px 0 0 28px;}
.footerContainer .col > a.social {display:block; margin:10px 0; padding:4px 0 0 41px; color:#595959; height:18px; font-size:11px;white-space: nowrap;}
.footerContainer .col > a.social.facebook {background:url(./images/footerSocialIconFb.png) left top no-repeat;}
.footerContainer .col > a.social.twitter {background:url(./images/footerSocialIconTwit.png) left top no-repeat;}
.footerContainer .col > a.social.pinterest { background:url(./images/footerSocialIconPin.png)  left top no-repeat;}
.footerContainer .col > a.social.youtube {background:url(./images/youtube_footer.png) left top no-repeat;}
.footerContainer .col > a.social.instagram { background:url(./images/instagram.png)  left top no-repeat;}
.footerContainer .col > a.social:hover {color:#0f67b1;}
.footerContainer .col ul {padding:2px 0 0 10px; line-height:1.2; width:150px;}
.footerContainer .col ul li {display:block; padding:3px 0;}
.footerContainer .col ul li a {color:#595959; font-size:11px;}
.footerContainer .col ul li a:hover {color:#999;}
.footerContainer .col ul .heading a {text-transform:uppercase; font-weight:bold; font-size:11px; text-shadow:#6c6c6c 0 0 0;}

.footerContainer .col ul li.expandable {position:relative; background:url(./images/footerSelect.png) no-repeat; width:150px; height:20px; left:-10px; padding:2px 0 4px 10px;}
.footerContainer .col ul li.expandable a {padding-top:1px; display:block;}
.footerContainer .col ul li.expandable .popup {display:none; position:absolute; z-index:100; left:0; bottom:0; width:151px; background-color:#FFF; padding:5px 0; border-radius:3px; height:175px; overflow-x:hidden; overflow-y:scroll; border:1px solid #999;}
.footerContainer .col ul li.expandable .popup .top {display:block; width:170px; height:7px; background-image:url(); position:absolute; left:0; top:-7px;}
.footerContainer .col ul li.expandable .popup .bottom {display:block; width:170px; height:20px; background-image:url(); position:absolute; left:0; bottom:-20px;}
.footerContainer .col ul li.expandable .popup a {color:#535353; display:block; text-align:left; padding:2px 10px;}
.footerContainer .col ul li.expandable .popup a:hover {background-color:#e2f3ff;}

.footerContainer .col ul li.external {position:relative; background-image:url(); background-position:0 100%; background-repeat:no-repeat; height:15px; padding:2px 0 4px 15px;; left:-15px;}
.footerContainer .col ul li.external:hover {background-position:0 0;}
/* FOOTER BASE */

.footerBaseWrap {background:url(./images/footerSubBg.png) top repeat-x; height:43px;}
.footerBaseWrap * {position:relative; z-index:5;}
.footerBaseContainer {height:43px; position:relative; overflow:hidden;}
.footerCenterWrap {float:left; left:50%;}
.footerBaseContainer a {color:#595959; display:block; float:left; height:30px; margin:0 12px; padding-top:13px; right:50%;}
.footerBaseContainer a.divider {padding-right:33px; border-right:1px dotted #AAA; margin-right:19px;}
.footerBaseContainer a:hover {color:#999;}
.parentWrap{
  background-color: #e4e4e4!important;
}
.spoontext {
    width: 210px;
    padding-left: 40px;
    position: absolute;
    z-index: 6;
    top: -8px;
    display: none;
    font-family: NeutraTBold;
    color: #E58BBC;
    font-size: 12px;
    height: 100px;
  }
  .clicktext {
                color: #E58BBC;
                display: none;
                float: left;
                font-family: NeutraTBold;
                font-size: 12px;
                left: 25px;
                padding-top: 3px;
                top: 60px;
                width: 210px;
                z-index: 44;
            }

.footerWrap {
  background: url(./images/footerBg.png) top repeat-x;
  height: 166px;
  clear: both;

}
.footerContainer {
}
.footerContainer .col {
  width: 137px;
  float: left;
  margin: 23px 25px 0 43px;
}
.footerContainer .col.spoonWrap {
  margin: 0 0 0 53px;
  position: relative;
  top: -13px;
  width: 82px;
}
.footerContainer .col.spoonWrap .spoon {
  display: block;
  width: 42px;
  height: 145px;
  background-image: url(./images/footerSpoon-2023.png);
  background-position: right;
}
.footerContainer .col.spoonWrap .spoon img {
  display: none;
  position: absolute;
  left: 36px;
  top: -18px;
  z-index: 100;
}
.footerContainer .col.spoonWrap .spoon:hover {
  background-position: left;
}
.footerContainer .col.spoonWrap .spoon:hover img {
  display: block;
}
.footerContainer .col.socialLinks {
  margin: 30px 0 0 28px;
}
.footerContainer .col > a.social {
  display: block;
  margin: 10px 0;
  padding: 4px 0 0 41px;
  color: #595959;
  height: 18px;
  font-size: 11px;
}
.footerContainer .col > a.social.facebook {
  background: url(./images/footerSocialIconFb.png) left top no-repeat;
}
.footerContainer .col > a.social.twitter {
  background: url(./images/footerSocialIconTwit.png) left top no-repeat;
}
.footerContainer .col > a.social.pinterest {
  background: url(./images/footerSocialIconPin.png) left top no-repeat;
}
.footerContainer .col > a.social.youtube {
  background: url(./images/youtube_footer.png) left top no-repeat;
}
.footerContainer .col > a.social.instagram {
  background: url(./images/instagram.png) left top no-repeat;
}
.footerContainer .col > a.social:hover {
  color: #0f67b1;
}
.footerContainer .col ul {
  padding: 2px 0 0 10px;
  line-height: 1.2;
  width: 150px;
}
.footerContainer .col ul li {
  display: block;
  padding: 3px 0;
}
.footerContainer .col ul li a {
  color: #595959;
  font-size: 11px;
}
.footerContainer .col ul li a:hover {
  color: #999;
}
.footerContainer .col ul .heading a {
  text-transform: uppercase;
  font-weight: bold;
  font-size: 11px;
  text-shadow: #6c6c6c 0 0 0;
}

.footerContainer .col ul li.expandable {
  position: relative;
  background: url(./images/footerSelect.png) no-repeat;
  width: 150px;
  height: 20px;
  left: -10px;
  padding: 2px 0 4px 10px;
}
.footerContainer .col ul li.expandable a {
  padding-top: 1px;
  display: block;
}
.footerContainer .col ul li.expandable .popup {
  display: none;
  position: absolute;
  z-index: 100;
  left: 0;
  bottom: 0;
  width: 151px;
  background-color: #fff;
  padding: 5px 0;
  border-radius: 3px;
  height: 175px;
  overflow-x: hidden;
  overflow-y: scroll;
  border: 1px solid #999;
}
.footerContainer .col ul li.expandable .popup .top {
  display: block;
  width: 170px;
  height: 7px;
  background-image: url();
  position: absolute;
  left: 0;
  top: -7px;
}
.footerContainer .col ul li.expandable .popup .bottom {
  display: block;
  width: 170px;
  height: 20px;
  background-image: url();
  position: absolute;
  left: 0;
  bottom: -20px;
}
.footerContainer .col ul li.expandable .popup a {
  color: #535353;
  display: block;
  text-align: left;
  padding: 2px 10px;
}
.footerContainer .col ul li.expandable .popup a:hover {
  background-color: #e2f3ff;
}

.footerContainer .col ul li.external {
  position: relative;
  background-image: url();
  background-position: 0 100%;
  background-repeat: no-repeat;
  height: 15px;
  padding: 2px 0 4px 15px;
  left: -15px;
}
.footerContainer .col ul li.external:hover {
  background-position: 0 0;
}
/* FOOTER BASE */

.footerBaseWrap {
  background: url(./images/footerSubBg.png) top repeat-x;
  height: 43px;
}
.footerBaseWrap * {
  position: relative;
  z-index: 5;
}
.footerBaseContainer {
  height: 43px;
  position: relative;
  overflow: hidden;
}
.footerCenterWrap {
  float: left;
  left: 50%;
}
.footerBaseContainer a {
  color: #595959;
  display: block;
  float: left;
  height: 30px;
  margin: 0 12px;
  padding-top: 13px;
  right: 50%;
}
.footerBaseContainer a.divider {
  padding-right: 33px;
  border-right: 1px dotted #aaa;
  margin-right: 19px;
}
.footerBaseContainer a:hover {
  color: #999;
}
.parentContainer {width:960px; height:100%; margin:0 auto; position:relative;}

@media screen and (max-width: 760px) {
  .footerWrap {
    height: auto!important;
}
.footerBaseWrap{
  height: auto;
}
  .footerBaseContainer {
    height: auto !important;
    padding-top: 20px !important;
  }

  .footerCenterWrap {
    width: 100% !important;
    left: 25px !important;
    height: 100px !important;
  }

  .footerCenterWrap a {
    float: left !important;
    width: 100% !important;
    right: 0px !important;
    height: 100% !important;
    display: contents !important;
  }
  /*  .heroWrap .contentWrap * {
            display:none!important;
          }*/

  
  .footerContainer .col {
    width: 25% !important;
    float: left;
    margin: 30px 20px 0 20px !important;
    padding: 0;
  }
  .footerContainer .col > a.social {
    display: block;
    margin: 5px 0 !important;
    padding: 4px 0 0 41px;
    color: #595959;
    height: 18px;
    font-size: 11px;
  }
  .footerContainer {
    width: 100% !important;
    float: left;
  }
  .footerContainer .col.spoonWrap {
    margin: 0 0 0 0px !important;
    position: relative;
    top: -13px;
    width: 82px;
  }
  .footerContainer .col ul {
    /* padding: 2px 0 0 10px; */
    line-height: 1.2;
    width: 100% !important;
  }
}
@media screen and (min-width: 768px) and (max-width: 1300px) {
  
  .footerBaseContainer {
    // height: 150px !important;
    padding-top: 20px !important;
  }

  .footerCenterWrap {
    width: 100% !important;
    left: 0px !important;
    height: 100px !important;
    font-size: 11px;
  }

  .footerCenterWrap a {
    float: left !important;
    width: 100% !important;
    right: 0px !important;
    height: 100% !important;
    display: contents !important;
     
  }
  /*.heroWrap .contentWrap * {
    display:none!important;
  }*/

  .footerContainer .col {
    margin: 20px 20px 0 20px;
  }
}
@media screen and (max-width: 760px) {
  // .footerContainer .col{
  //   width:25%!important;
  //   float: left;
  // }
  // .footerContainer{
  //   width:40%!important;
  //   float: left;
  // }
  .parentWrap{
    width: 100% !important;
    min-width: inherit;
    }
    .socialWrap{
      padding-bottom: 10px!important;
    }
    .parentContainer {
      width: 91%!important;
  }
  .footerContainer .col.spoonWrap {
    margin: 0 0 0 0px !important;
    position: relative;
    top: -13px;
    width: 82px;
  }
  .footerContainer .col ul {
    /* padding: 2px 0 0 10px; */
    line-height: 1.2;
    width: 100% !important;
    font-size: 11px;
  }
  .footerContainer .col > a.social {
    display: block;
    margin: 5px 0!important;
    padding: 4px 0 0 41px;
    color: #595959;
    height: 18px;
    font-size: 11px;
}
.footerContainer .col {
    width: 25%!important;
    float: left;
    padding:0px!important;
    margin: 30px 20px 0 20px!important;
    padding:0px!important;
  }
}
</style>
